export const MONTH_LIST = {
  1: {
    id: 1,
    title: 'January',
    shortTitle: 'Jan',
    maxDaysCount: 31,
  },
  2: {
    id: 2,
    title: 'February',
    shortTitle: 'Feb',
    maxDaysCount: 29,
  },
  3: {
    id: 3,
    title: 'March',
    shortTitle: 'Mar',
    maxDaysCount: 31,
  },
  4: {
    id: 4,
    title: 'April',
    shortTitle: 'Apr',
    maxDaysCount: 30,
  },
  5: {
    id: 5,
    title: 'May',
    shortTitle: 'May',
    maxDaysCount: 31,
  },
  6: {
    id: 6,
    title: 'June',
    shortTitle: 'June',
    maxDaysCount: 30,
  },
  7: {
    id: 7,
    title: 'July',
    shortTitle: 'July',
    maxDaysCount: 31,
  },
  8: {
    id: 8,
    title: 'August',
    shortTitle: 'Aug',
    maxDaysCount: 31,
  },
  9: {
    id: 9,
    title: 'September',
    shortTitle: 'Sep',
    maxDaysCount: 30,
  },
  10: {
    id: 10,
    title: 'October',
    shortTitle: 'Oct',
    maxDaysCount: 31,
  },
  11: {
    id: 11,
    title: 'November',
    shortTitle: 'Nov',
    maxDaysCount: 30,
  },
  12: {
    id: 12,
    title: 'December',
    shortTitle: 'Dec',
    maxDaysCount: 31,
  },
}
